import moment from "moment";
import { CURRENCY } from "../constant/constants";
import axios from "axios";
import { toast } from "react-toastify";
import { formRegEx, formRegExReplacer } from "constant/regex";
import Skeleton from "components/Skeleton";
import RenderToast from "components/Core/RenderToast";

export const thousandToK = (num) => {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(1) + "K";
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  } else if (num < 900) {
    return num;
  }
};

export const kebabCase = (string) =>
  string
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase();

//TODO:
export const interpolateString = (str, valueObj) => {
  if (typeof str !== "string") {
    return "";
  }
  for (let key in valueObj) {
    return str.replace(`{${key}}`, valueObj[key]);
  }
};

export const formatMessageDate = (date) => {
  const messageDate = moment(date);
  const now = moment();

  if (messageDate.isSame(now, "minute")) {
    // If the date is exactly now, show the current time, e.g., 'HH:mm A'
    return now.format("HH:mm A");
  } else if (messageDate.isSame(now, "day")) {
    // If the date is today, use fromNow()
    return messageDate.fromNow();
  } else if (messageDate.isSame(now.subtract(1, "day"), "day")) {
    // If the date is yesterday, use fromNow()
    return messageDate.fromNow();
  } else {
    // Otherwise, show the date in a standard format, e.g., 'MM/DD/YYYY'
    return messageDate.format("MM/DD/YYYY");
  }
};

export const formatDate = (date) => {
  const formdatedDate = moment(date);
  return formdatedDate.format("MM/DD/YYYY");
};

export const formatTime = (time) => {
  const formattedTime = moment(time);
  return formattedTime.format("hh:mm A");
};
export function stripAllHtmlTags(input) {
  return input?.replace(/<[^>]*>?/gm, "");
}

const options = {
  onDownloadProgress: (progressEvent) => {
    const { loaded, total } = progressEvent;
  },
};
export function downloadFileFromUrl(fileUrl, filename) {
  axios
    .get(fileUrl, {
      responseType: "blob",
      ...options,
    })
    .then(function (response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers["content-type"],
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {});
}

export const scrollToTop = (topVal = 0) => {
  window.scrollTo({
    top: topVal,
    behavior: "smooth",
  });
};

export const formatNumber = (num) => {
  if (num % 1 === 0) {
    return `${CURRENCY}${num?.toLocaleString()}`;
  } else {
    return `${CURRENCY}${num?.toFixed(2)?.toLocaleString()}`;
  }
};

export const bytesToMB = (bytes) => {
  return bytes / (1024 * 1024);
};

export async function convertImageFile(file) {
  if (typeof window !== "undefined") {
    const heic2any = require("heic2any");
    if (file?.type === "image/heic") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
        });
        return new File(
          [convertedBlob],
          file.name.replace(/\.heic$/i, ".jpg"),
          {
            type: "image/jpeg",
            lastModified: Date.now(),
          }
        );
      } catch (error) {
        console.error("Error converting HEIC to JPEG:", error);
        throw error;
      }
    } else if (file?.type === "image/webp") {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.src = URL.createObjectURL(file);
        await new Promise((resolve) => {
          img.onload = resolve;
        });
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        return new Promise((resolve) => {
          canvas.toBlob((blob) => {
            const convertedFile = new File(
              [blob],
              file.name.replace(/\.webp$/i, ".jpg"),
              {
                type: "image/jpeg",
                lastModified: Date.now(),
              }
            );
            resolve(convertedFile);
          }, "image/jpeg");
        });
      } catch (error) {
        console.error("Error converting WebP to JPEG:", error);
        throw error;
      }
    }
    return file;
  }
}
export const handleConvertImages = async (files) => {
  // return files;
  const temp = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (typeof file === "string") {
      temp.push(file);
    } else {
      const image = await convertImageFile(file);
      temp.push(image);
    }
  }
  return temp;
};

export const RemoveComma = (value) => {
  // Remove commas and convert to a number
  const numberValue = value.replace(/,/g, "");
  return numberValue;
};

export const quillValidateHandler = (
  params,
  toastMessage = "Please fill the home cms field!"
) => {
  let flag = true;
  for (let key in params) {
    const parsedHTML = new DOMParser().parseFromString(
      params[key],
      "text/html"
    );
    const plainText = parsedHTML.body.textContent || "";
    if (plainText?.trim() === "") {
      toast.error(toastMessage);
      flag = false;
      break;
    }
  }
  return flag;
};

export const validateDate = (date) => {
  if (!date) return null; // Return null if date is falsy

  // Check if date is a moment object and has a $d property
  if (date?.$d) {
    return moment(date.$d).format(); // Format if $d exists
  } else {
    return moment(date).format(); // Assume date is a valid input for moment
  }
};
export const calculateRaiseGoalPercentage = (raisedAmount, goalAmount) => {
  return (raisedAmount * 100) / goalAmount;
};
export const validateProductLinks = (links) => {
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    for (let linkKey in link) {
      if (!link[linkKey]) {
        toast.error(`${linkKey} cannot be empty for link ${i + 1}`);
        return false;
      }
    }
  }
  return true;
};
export const displayPhoneNumber = (phone, dialCode) => {
  return phone ? `${dialCode}${phone}` : "--";
};

export const validateUrl = (url) => {
  const urlRegex =
    /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  return urlRegex.test(url);
};

export const urlPattern =
  /^(https?:\/\/)(www\.)?([\w-]+\.)+[a-z]{2,6}(\/[\w-]*)*\/?$/;
export const serviceTransformToRender = (items) => {
  return items.reduce((acc, item, index, arr) => {
    const serviceDuplicateIndx = acc.findIndex(
      (ele) => ele?.advertisement?._id === item?.advertisement._id
    );
    if (serviceDuplicateIndx === -1) {
      const date = moment(item?.date).format("DD/MM/YYYY");
      acc.push({
        services: {
          [date]: [item],
        },
        advertisement: item?.advertisement,
      });
    } else {
      const date = moment(item?.date).format("DD/MM/YYYY");
      acc[serviceDuplicateIndx].services[date]
        ? acc[serviceDuplicateIndx].services[date].push(item)
        : (acc[serviceDuplicateIndx].services[date] = [item]);
    }
    return acc;
  }, []);
};
export const convertToMilitaryTime = (timeStr) => {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
};
export const convertFromMilitaryTime = (timeStr, dateStr) => {
  let [hours, minutes] = timeStr.split(":").map(Number);
  const date = new Date(dateStr);

  // Set the hours and minutes based on the military time provided
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);

  // Return the full date string in the specified format
  return date;
};
export const compareTimes = (start, end) => {
  // Helper function to convert time string to minutes since midnight
  function timeToMinutes(time) {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const minutes1 = timeToMinutes(start);
  const minutes2 = timeToMinutes(end);

  // Compare the two times
  if (minutes1 > minutes2) {
    return false;
  } else {
    return true;
  }
};
export const camelCaseToLower = (str) => {
  return str.replace(formRegEx, formRegExReplacer).toLowerCase();
};
export const uniqueItems = (items) => {
  return items?.filter((item, index, arr) => {
    return (
      arr.findIndex(
        (ele) => ele?.advertisement?._id === item?.advertisement?._id
      ) === index
    );
  });
};

export const getYearRange = () => {
  const years = [
    // {
    //   label: "All",
    //   value: "all",
    // },
    ...Array.from({ length: 3 }).map((_, i) => ({
      label: `${moment().subtract(i, "year").format("YYYY")}`,
      value: `${moment().subtract(i, "year").format("YYYY")}`,
    })),
  ];
  return years;
};

export const colorPalette = [
  "#D62828",
  "#57cc99",
  "#F4A261",
  "#E9C46A",
  "#C7C7C7",
  "#4D4D4D",
  "#ff0000",
];

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const renderSkeleton = (width, height, variant = "rounded") => (
  <Skeleton width={width} height={height} variant={variant} />
);

export const checkIsArray = (value) => {
  return Array.isArray(value) && value.length > 0;
};

export const checkImageDimensions = (file, width, height) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = function () {
      if (img.width < width || img.height < height) {
        RenderToast({
          type: "error",
          message: `Image size should be ${width} x ${height}`,
        });
        reject("Invalid image size");
      } else {
        resolve();
      }
    };
  });
};
